exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2l_aLykwwbjw9h4dmPqjw4 {\n}\n._18BVOO0p9Wapy6YZYBZ3d {\n  width: 600px;\n  -webkit-transform: scale(.6, .6);\n      -ms-transform: scale(.6, .6);\n          transform: scale(.6, .6);\n  -webkit-transform-origin: 0 0;\n      -ms-transform-origin: 0 0;\n          transform-origin: 0 0;\n  background-color: #fff;\n}\n._2FqK82GZVIwDKhkwmcGFAu {\n  -webkit-transform: scale(.6, .6) translate(0, -17px);\n      -ms-transform: scale(.6, .6) translate(0, -17px);\n          transform: scale(.6, .6) translate(0, -17px);\n}\n", ""]);

// exports
exports.locals = {
	"eKGPreview": "_2l_aLykwwbjw9h4dmPqjw4",
	"previewGridNoTranslate": "_18BVOO0p9Wapy6YZYBZ3d",
	"previewGrid": "_2FqK82GZVIwDKhkwmcGFAu _18BVOO0p9Wapy6YZYBZ3d"
};


//////////////////
// WEBPACK FOOTER
// /Users/travis/build/alivecor/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/Users/travis/build/alivecor/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/components/EKGPreview/EKGPreview.css
// module id = 9706
// module chunks = 23